import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

export default class TimeAgo extends React.Component {
  render () {
    const ts = this.props.timestamp;
    const ago = moment(ts * 1000).fromNow();
    return (
      <span>{ ago }</span>
    );
  }
}

TimeAgo.propTypes = {
  timestamp: PropTypes.number.isRequired
};




// WEBPACK FOOTER //
// ./src/components/static/time.js